import { render } from "./CalendarEventSave.vue?vue&type=template&id=89ffabe6&scoped=true"
import script from "./CalendarEventSave.vue?vue&type=script&lang=ts"
export * from "./CalendarEventSave.vue?vue&type=script&lang=ts"

import "./CalendarEventSave.vue?vue&type=style&index=0&id=89ffabe6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-89ffabe6"

export default script